import {
  Checkbox,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
} from "@material-ui/core";
import React, { useState } from "react";
import { Button, Col, Modal, Tab, Table, Tabs } from "react-bootstrap";
// import clsx from "clsx";
// import { lighten, makeStyles } from "@material-ui/core/styles";
// import { Row } from "reactstrap";

import { connect } from "react-redux";

import { setAffectationMntRetenuALaSourceCli } from "../../redux/actions/SetAffectationMntRetenuALaSourceCli";
import { setAffectationRegClient } from "../../redux/actions/SetAffectationRegCli";
const AffectationRetenuALaSourceCli = (props) => {
  const [key, setKey] = useState("Facture");
  //   const [orderBy, setOrderBy] = useState("");
  //   const [order, setOrder] = useState("asc");

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("codcli");
  const [selected, setSelected] = React.useState([]);
  const [blselected, setBLselected] = React.useState([]);
  const [detailTab, setdetailTab] = React.useState([]);
  const [searchFac, setSearchFac] = React.useState([]);

  const [IsSearchFac, setIsSearchFac] = React.useState(false);
  //const [searchBL, setSearchBL] = React.useState([]);
  //   const [IsSearchBL, setIsSearchBL] = React.useState(false);
  //   const [IsSearchAV, setIsSearchAV] = React.useState(false);
  //   const [searchAV, setSearchAV] = React.useState([]);
  //   const [selectedAV, setAVSelected] = React.useState([]);
  const DATE_OPTIONS = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const classes = {
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      for (let n = 0; n < props.listeFacture.length; n++) {
        setdetailTab(
          detailTab.push({
            numfac: props.listeFacture[n].numfac,
            montant: props.listeFacture[n].mntbon,
            datfac: props.listeFacture[n].datfac,
            typfac: props.listeFacture[n].typfac,
            monreg:
              (props.listeFacture[n].reste * parseFloat(props.chdec)) / 100,

            regant: Number(
              props.listeFacture[n].mntbon - props.listeFacture[n].reste
            ).toFixed(3),
          })
        );

        //   newSelecteds.push({
        //     numfac: n.numfac,
        //     montant: n.mntbon,
        //     datfac: n.datfac,
        //     typfac: n.typfac,
        //     monreg: Math.min(
        //       n.reste,
        //       props.montReg - detailTab.reduce((a, v) => a + v.monreg, 0)
        //     ),
        //     regant: Number(n.mntbon - n.reste).toFixed(3),
        //   });
        //   return newSelecteds;
        // }

      }
      setdetailTab(detailTab);
      const newSelecteds = props.listeFacture.map((n) => ({
        numfac: n.numfac,
        montant: n.mntbon,
        datfac: n.datfac,
        typfac: n.typfac,
        monreg: (props.listeFacture[n].reste * parseFloat(props.chdec)) / 100,
        regant: Number(n.mntbon - n.reste).toFixed(3),
      }));
      setSelected(newSelecteds);

      return;
    }

    setSelected([]);
    setdetailTab(blselected);

  };
  const handleSelectBLAllClick = (event) => {
    if (event.target.checked) {
      for (let n = 0; n < props.listebl.length; n++) {
        setdetailTab(
          detailTab.push({
            numfac: props.listebl[n].numfac,
            montant: props.listebl[n].mntbon,
            datfac: props.listebl[n].datfac,
            typfac: props.listebl[n].typfac,
            monreg: Math.min(
              props.listebl[n].reste,
              props.montReg - detailTab.reduce((a, v) => a + v.monreg, 0)
            ),
            regant: Number(
              props.listebl[n].mntbon - props.listebl[n].reste
            ).toFixed(3),
          })
        );
      }
      setdetailTab(detailTab);
      const newSelecteds = props.listebl.map((n) => ({
        numfac: n.numfac,
        montant: n.mntbon,
        datfac: n.datfac,
        typfac: n.typfac,
        monreg: (props.listeFacture[n].reste * parseFloat(props.chdec)) / 100,
        regant: Number(n.mntbon - n.reste).toFixed(3),
      }));

      setBLselected(newSelecteds);

      return;
    }
    alert(`fac ${selected.length == props.listeFacture.length}`);

    setBLselected([]);
    setdetailTab(selected);
  };
  const handleClick = (event, obj) => {
    const selectedIndex = selected.map((el) => el.numfac).indexOf(obj.numfac);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, obj);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
    setdetailTab(newSelected);
  };

  const isSelected = (obj) =>
    selected.filter((el) => el.numfac == obj.numfac).length > 0;

  const enregistrer = () => {
    props.setAffectationRegCli(detailTab);
    props.setAffectationMntRetenuALaSource(
      detailTab.reduce((c, v) => c + parseFloat(v.monreg), 0).toFixed(3)
    );
    props.handleClose();
  };
  const rechercheHandler = (a) => {
    if (a.length != 0) {
      fetch(
        `https://www.24-crm.tn/webservice/api/FACCLIs/${a}?codcliii=${props.codeclient}&coddos=${props.ConfigDossier.coddos}&serveur=${props.ConfigDossier.serveur}&user=${props.ConfigDossier.utilisateur}&pwd=${props.ConfigDossier.pwd_serveur}&database=${props.ConfigDossier.database}`
      )
        .then((response) => response.json())
        .then((data) => {
          setIsSearchFac(true);
          setSearchFac(
            data.filter((el) => el.typfac == "FF" && el.reste > 0.001)
          );
        });
    } else {
      setIsSearchFac(false);
    }
  };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={props.handleClose} centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "white", color: "#020F64" }}
        >
          <Modal.Title>
            <b>Affectation</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            style={{ color: "rgb(23, 162, 184)" }}
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab eventKey="Facture" title="Facture">
              <TextField
                id="filled-full-width"
                placeholder="Recherche facture"
                fullWidth
                margin="dense"
                onChange={(e) => rechercheHandler(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <div className="tabftre">
                <Table>
                  <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    rowCount={props.listeFacture.length}
                  />
                  <TableBody>
                    {stableSort(
                      IsSearchFac ? searchFac : props.listeFacture,
                      getComparator(order, orderBy)
                    ).map((test, index) => {
                      const isItemSelected = isSelected({
                        numfac: test.numfac,
                        montant: test.mntbon,
                        datfac: test.datfac,
                        typfac: test.typfac,
                        reste: test.reste,
                        regant: Number(test.mntbon - test.reste).toFixed(3),
                        monreg: (test.mntbon * parseFloat(props.chdec)) / 100,
                      });
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow
                          onClick={(event) =>
                            handleClick(event, {
                              numfac: test.numfac,
                              montant: test.mntbon,
                              datfac: test.datfac,
                              typfac: test.typfac,
                              reste: test.reste,
                              monreg:
                                (test.mntbon * parseFloat(props.chdec)) / 100,
                              regant: Number(test.mntbon - test.reste).toFixed(
                                3
                              ),
                            })
                          }
                          role="checkbox"
                          // aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={{
                            numfac: test.numfac,
                            montant: test.mntbon,
                          }}
                          // selected={isItemSelected}
                        >
                          <TableCell>
                            <Checkbox
                              checked={isItemSelected}
                              color="primary"
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </TableCell>
                          <TableCell>{test.numfac}</TableCell>
                          <TableCell>{test.typfac}</TableCell>
                          <TableCell>
                            {new Date(test.datfac).toLocaleDateString(
                              "fr",
                              DATE_OPTIONS
                            )}
                          </TableCell>

                          <TableCell>{test.raisoc}</TableCell>

                          <TableCell>{test.codcli}</TableCell>

                          <TableCell>
                            {Number(test.mntbon).toFixed(3)}
                          </TableCell>
                          <TableCell>
                            {Number(test.mntbon - test.reste).toFixed(3)}
                          </TableCell>
                          <TableCell>{Number(test.reste).toFixed(3)}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Col md={12}>
            <h5>Détails</h5>
            <div className="tabcf">
              <table>
                <thead>
                  <tr>
                    <th>Numéro</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Montant</th>
                    <th>Reg.Ant</th>
                    <th>Reglement</th>
                  </tr>
                </thead>
                <tbody>
                  {detailTab.map((el) => (
                    <tr>
                      <td>{el.numfac}</td>
                      <td>{el.typfac}</td>

                      <td>{new Date(el.datfac).toLocaleDateString()}</td>
                      <td>{el.montant.toFixed(3)}</td>
                      <td>{el.regant}</td>
                      <td>{el.monreg.toFixed(3)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
          <Col sm={{ span: 6, offset: 6 }} style={{ marginTop: "10%" }}>
            <Table>
              <TableBody>
                {/* <TableRow rowSpan={4}>
                        <TableCell>Montant Total</TableCell>
                        <TableCell>
                          {props.listeFacture
                            .reduce((c, v) => c + parseFloat(v.mntbon), 0)
                            .toFixed(3)}
                        </TableCell>
                      </TableRow> */}
                <TableRow rowSpan={4}>
                  <TableCell>Montant Affecté</TableCell>
                  <TableCell>
                    {detailTab
                      .reduce((c, v) => c + parseFloat(v.monreg), 0)
                      .toFixed(3)}
                  </TableCell>
                </TableRow>
                <TableRow rowSpan={4}>
                  <TableCell>Montant Règlement</TableCell>
                  <TableCell>
                    {" "}
                    {detailTab
                      .reduce((c, v) => c + parseFloat(v.monreg), 0)
                      .toFixed(3)}
                  </TableCell>
                </TableRow>
                <TableRow rowSpan={4}>
                  <TableCell align="left">Solde Global</TableCell>
                  <TableCell>
                    {/* {(
                            parseFloat(
                              selected.reduce((c, v) => c + parseFloat(v.montant), 0)
                            ) - parseFloat(props.montReg)
                          ).toFixed(3)} */}
                    {props.soldfacbl.toFixed(3)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Col>

          <Col md={12}>
            <Button variant="primary" onClick={enregistrer}>
              Enregistrer
            </Button>
          </Col>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAffectationRegCli: (num) => dispatch(setAffectationRegClient(num)),
    setAffectationMntRetenuALaSource: (num) =>
      dispatch(setAffectationMntRetenuALaSourceCli(num)),
  };
};
function mapStateToProps(state) {
  return {
    ConfigDossier: state.ConfigDossier,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AffectationRetenuALaSourceCli);

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCells = [
  { id: "numfac", numeric: true, disablePadding: true, label: "N°" },
  { id: "typfac", numeric: true, disablePadding: true, label: "type" },
  { id: "datfac", numeric: true, disablePadding: true, label: "Date" },

  {
    id: "raisoc",
    numeric: true,
    disablePadding: false,
    label: "Raison Sociale",
  },

  {
    id: "codcli",
    numeric: true,

    label: "Code Client",
  },

  { id: "mntbon", numeric: true, disablePadding: false, label: "Montant" },
  {
    id: "",
    numeric: true,
    disablePadding: false,
    label: "Tot.Reg",
  },
  {
    id: "reste",
    numeric: true,

    label: "Reste",
  },
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell>
          {/* <Checkbox
                  indeterminate={numSelected > 0 && numSelected < rowCount}
                  checked={rowCount > 0 && numSelected === rowCount}
                  onChange={onSelectAllClick}
                  inputProps={{ "aria-label": "select all desserts" }}
                /> */}
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "" : ""}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
